import { Component, ViewChild } from '@angular/core';
import { MashoManagerListingComponent } from './masho-manager-listing/masho-manager-listing.component';

@Component({
  selector: 'app-masho-manager',
  templateUrl: './masho-manager.component.html',
  styleUrls: ['./masho-manager.component.scss']
})
export class MashoManagerComponent {

  @ViewChild('mashoListing') mashoListingComponent!: MashoManagerListingComponent;

  onMashoAdded(): void {
    console.log('Masho added successfully');
    // Trigger refresh of the masho listing
    if (this.mashoListingComponent) {
      this.mashoListingComponent.onMashoAdded();
    }
  }

  onMashoUpdated(): void {
    console.log('Masho updated successfully');
    // Trigger refresh of the masho listing
    if (this.mashoListingComponent) {
      this.mashoListingComponent.onMashoUpdated();
    }
  }
}
